export default class Alert {
  constructor(type,title,text) {
    Object.assign(this,{type,title,text})
  }
}